(function ($) {
  $(document).ready(function () {
    // 기본 autoplay delay 값
    var DEFAULT_AUTOPLAY_DELAY = 3000;
    var VIDEO_AUTOPLAY_DELAY = 30000;

    var main_bnr = new Swiper(".main_slide .swiper-container", {
      speed: 1000,
      loop: true,
      autoplay: {
         delay: DEFAULT_AUTOPLAY_DELAY,
         disableOnInteraction: false,
      },
      spaceBetween: 10,
      navigation: {
        nextEl: ".main_slide .swiper-button-next",
        prevEl: ".main_slide .swiper-button-prev",
      },
      pagination: {
        el: ".main_slide .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        990: {
          spaceBetween: 20,
        },
      },

      on: {
        // 슬라이드/pagination bullet DOM이 모두 준비된 시점
        init: function () {
          handleSlideChange(this);
        },
        // loop 모드에서 클론 슬라이드로 인한 인덱스 어긋남을 피하기 위해
        // 트랜지션이 "끝난" 시점(transitionEnd)에 처리한다.
        // (transitionStart 시점엔 loopFix 전이라 activeIndex가 클론을 가리킬 수 있음)
        slideChangeTransitionEnd: function () {
          handleSlideChange(this);
        },
        // pagination bullet이 다시 그려질 때(bullet 개수/순서가 바뀔 때)도
        // 활성 bullet에 progress 애니메이션을 다시 적용해줘야 함
        paginationRender: function () {
          handleSlideChange(this);
        },
        paginationUpdate: function () {
          syncActiveBulletProgress(this);
        },
      },
    });

    /**
     * 활성 슬라이드 상태에 따라:
     * - swiper_video면 autoplay delay 30초로 변경
     * - 해당 슬라이드의 visible video 재생, 나머지는 정지
     * - bullet progress 동기화
     *
     * realIndex 기준으로 실제 슬라이드를 찾기 때문에
     * loop 클론/슬라이드 개수 변경에 영향을 받지 않는다.
     */
    function handleSlideChange(swiper) {
      var activeSlide = getRealActiveSlide(swiper);
      var isVideoSlide =
        activeSlide && activeSlide.classList.contains("swiper_video");
      var newDelay = isVideoSlide ? VIDEO_AUTOPLAY_DELAY : DEFAULT_AUTOPLAY_DELAY;

      // 1) 모든 슬라이드의 비디오 중지 및 초기화
      swiper.slides.forEach(function (slide) {
        var videos = slide.querySelectorAll("video");
        videos.forEach(function (v) {
          try {
            v.pause();
            v.currentTime = 0;
          } catch (e) {
            /* 안전하게 무시 */
          }
        });
      });

      // 2) 현재 활성 슬라이드의 visible video만 재생
      if (isVideoSlide) {
        var visibleVideos = Array.from(
          activeSlide.querySelectorAll("video")
        ).filter(function (v) {
          return v.offsetParent !== null;
        });
        visibleVideos.forEach(function (v) {
          v.muted = true;
          v.playsInline = true;
          var playPromise = v.play();
          if (playPromise !== undefined) {
            playPromise.catch(function (err) {
              console.log("video play 실패:", err);
            });
          }
        });
      }

      // 3) autoplay delay 갱신
      //    - stop()/start()로 껐다 켜지 않고 delay 값만 바꾼 뒤
      //      다음 사이클부터 적용되도록 한다 (불필요한 setTimeout 제거)
      swiper.params.autoplay.delay = newDelay;
      if (swiper.autoplay && swiper.autoplay.running) {
        // 진행 중인 타이머를 새 delay로 다시 시작
        swiper.autoplay.stop();
        swiper.autoplay.start();
      }

      // 4) pagination bullet progress 동기화
      syncActiveBulletProgress(swiper, newDelay);
    }

    /**
     * loop 모드에서 실제(원본) 활성 슬라이드 엘리먼트를 반환.
     * swiper.slides[swiper.activeIndex] 대신 realIndex + data-swiper-slide-index
     * 를 이용해 클론 여부와 무관하게 정확한 슬라이드를 찾는다.
     */
    function getRealActiveSlide(swiper) {
      var realIndex = swiper.realIndex;
      var match = swiper.slides.filter(function (slide) {
        return (
          !slide.classList.contains("swiper-slide-duplicate") &&
          Number(slide.getAttribute("data-swiper-slide-index")) === realIndex
        );
      })[0];
      // data-swiper-slide-index가 없는 구성이면 activeIndex로 폴백
      return match || swiper.slides[swiper.activeIndex];
    }

    /**
     * pagination bullet의 progress 애니메이션을 현재 delay 기준으로 재적용.
     * setTimeout 폴링 대신 Swiper가 제공하는 paginationUpdate/paginationRender
     * 이벤트 시점에 호출되므로, bullet DOM이 항상 준비된 상태에서 실행된다.
     */
    function syncActiveBulletProgress(swiper, delay) {
      var effectiveDelay =
        delay ||
        (swiper.params.autoplay && swiper.params.autoplay.delay) ||
        DEFAULT_AUTOPLAY_DELAY;

      var $bullets = $(".main_slide .swiper-pagination-bullet");
      var $activeBullet = $(".main_slide .swiper-pagination-bullet-active");

      if ($activeBullet.length === 0) return;

      $bullets.removeClass("progress");
      $activeBullet.css("--progress-time", effectiveDelay + "ms");
      // reflow를 강제해 CSS 애니메이션(progress 클래스)이 재시작되도록 함
      void $activeBullet[0].offsetWidth;
      $activeBullet.addClass("progress");
    }
  });
})(jQuery);